import React from "react";

export const LoadingSpinner: React.FC = () => {
  return (
    <div className="p-6 text-center">
      <div className="inline-block w-10 h-10 border-4 border-gray-200 border-t-blue-500 rounded-full animate-spin"></div>
      <p>Ładowanie postów...</p>
    </div>
  );
};
